import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, styled, Typography } from '@mui/material';

import { RoundedButton } from '@/components/buttons';
import { SummaryBar } from '@/components/SummaryBar';
import { OrdersPaths } from '@/shared/lib/react-router';

import { useReconciliationOrderGuid } from '../reconciliation-file.store';
import { useReconciliationBindingActions } from './reconciliation-binding.store';
import { useUnboundDrugs } from './useLoadUnboundDrugs';

const ActionButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  flexGrow: 1,
  gap: 8,
});

export const ReconciliationBindingSummaryBar = () => {
  const { t } = useTranslation('orders-page');
  const navigate = useNavigate();
  const { data: unboundDrugs = [] } = useUnboundDrugs();
  const { openSkipDialog } = useReconciliationBindingActions();
  const orderGuid = useReconciliationOrderGuid();

  const hasUnboundDrugs = unboundDrugs.length > 0;

  const handleContinue = () => {
    navigate(OrdersPaths.RECONCILIATION_RESULT.replace(':orderGuid', orderGuid));
  };

  return (
    <SummaryBar sx={{ justifyContent: 'space-between', px: 4 }}>
      <Typography fontWeight="600">
        {unboundDrugs.length} {t('reconciliation.binding.unbound-title').toLowerCase()}
      </Typography>

      <ActionButtonContainer>
        {hasUnboundDrugs ? (
          <RoundedButton variant="contained" onClick={openSkipDialog}>
            {t('reconciliation.binding.actions.skip-binding')}
          </RoundedButton>
        ) : (
          <RoundedButton variant="contained" onClick={handleContinue}>
            {t('reconciliation.binding.actions.continue')}
          </RoundedButton>
        )}
      </ActionButtonContainer>
    </SummaryBar>
  );
};
